export enum MPL_PRODUCT_TYPES {
  CREDIT = 'credit',
  CREDIT_CARD = 'credit_card',
  MICROCREDIT = 'microcredit',
}

export type MplProductType = (typeof MPL_PRODUCT_TYPES)[keyof typeof MPL_PRODUCT_TYPES];

export enum MPL_PRODUCT_TYPES_RUSSIAN {
  credit = 'Кредит',
  credit_card = 'Кредитная карта',
  microcredit = 'Микрозайм',
}
